<app-pageheader [Parent]="this">
  <add-button AddRoute="/enforcement/officers/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="enforcement/officers/searches"
  [AllowEdit]="true" EditUrl="enforcement/officers/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-subset-filter [Subsets]="['Active','Inactive']"></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>


